import React from 'react';
import FullPageSuccess from 'components/FullPageSuccess';
import { createPartnerTransfersRoute } from 'adminConstants/routes';

const SuccessPage: React.FC = () => {
  return (
    <FullPageSuccess
      title="Partner transfer has been approved successfully"
      additionalText="The partner transfer has been processed and all allocations have been updated accordingly."
      proceedText="Create another partner transfer"
      proceedLink={createPartnerTransfersRoute()}
    />
  );
};

export default SuccessPage;
